import {
	DEFAULT_DIFFICULTY,
	type Difficulty,
	PACE,
	THREE_STARS_PER_SECOND,
	TWO_STARS_PER_SECOND,
} from "./constants";
import type { WorldState } from "./state";

/**
 * Stars for a finished round: 1 always, 2 and 3 for a score rate per second of round, scaled by
 * the difficulty (a calm round has fewer lights to catch).
 */
export function starsFor(
	score: number,
	seconds: number,
	difficulty: Difficulty = DEFAULT_DIFFICULTY,
): 1 | 2 | 3 {
	const rate = seconds > 0 ? score / seconds : 0;
	const scale = PACE[difficulty].starScale;
	if (rate >= THREE_STARS_PER_SECOND * scale) return 3;
	if (rate >= TWO_STARS_PER_SECOND * scale) return 2;
	return 1;
}

/** A finished round's numbers for the stats (Svit on). */
export function roundStats(world: WorldState) {
	const seen = world.collected + world.expired;
	return {
		/** Share of the lights collected (trick lights not counted), 0–100; null if none came. */
		hitPercent: seen > 0 ? Math.round((world.collected * 100) / seen) : null,
		longestStreak: world.longestStreak,
		misclicks: world.missed,
		/** Trick lights tapped; null without Minuspoäng or Mardröm (there are none then). */
		tricked: world.missPenalty || world.nightmare ? world.tricked : null,
	};
}
